import { useState, useCallback, useEffect } from 'react';
import { useDropzone } from 'react-dropzone';
import View from './view';
import { DocBoxProps, File } from './types';

const DocBox = ({ label, setValue, testID, aceptFiles, id, value }: DocBoxProps): JSX.Element => {
  const [files, setFiles] = useState<File[]>([]);
  const [isLoaded, setIsLoaded] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (value) {
      setFiles([
        {
          id,
          name: `${id}${aceptFiles}`,
        },
      ]);
      setIsLoaded(true);
    }
  }, []);

  const handler = (action): void => {
    action();
  };

  const getBase64string = (fileString: string): string => {
    const base64 = fileString.split(',')[1];
    return base64;
  };

  const createDocument = (acceptedFiles: string | ArrayBuffer | null): void => {
    if (acceptedFiles) {
      setValue(getBase64string(acceptedFiles?.toString()), id);
      setIsLoaded(true);
      setLoading(false);
    }
  };

  const deleteDocument = (file: File): void => {
    const newFiles = [...files];
    newFiles.splice(files.indexOf(file), 1);
    setFiles(newFiles);
    setValue('', id);
    setIsLoaded(false);
  };

  const onDrop = useCallback(acceptedFiles => {
    setLoading(true);
    const fileReader = new FileReader();
    const file = acceptedFiles[0];
    setFiles(acceptedFiles);
    fileReader.readAsDataURL(file);
    fileReader.onload = () => {
      handler(() => createDocument(fileReader.result));
    };
  }, []);

  const onDelete = (file: File): void => {
    handler(() => deleteDocument(file));
  };

  const acceptTypeFiles = {
    '.key': { 'application/x-pkcs12': ['.key'] },
    '.cer': { 'application/pkix-cert': ['.cer'] },
  };

  const {
    getRootProps,
    open: openBrowser,
    getInputProps,
    isDragActive,
  } = useDropzone({
    noClick: true,
    noKeyboard: true,
    onDrop,
    accept: acceptTypeFiles[aceptFiles],
  });
  return (
    <View
      testID={testID}
      files={files}
      loading={loading}
      isDragActive={isDragActive}
      isLoaded={isLoaded}
      getRootProps={getRootProps}
      getInputProps={getInputProps}
      onDeleteFile={onDelete}
      label={label}
      openBrowser={openBrowser}
      isRequired={false}
    />
  );
};

export default DocBox;
